// extracted by mini-css-extract-plugin
export default {"container":"fo-z","bubbleNav":"go-z","graphic":"ho-z","contact":"io-z"};